var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 分享海报 "),_c('quill-edit',{attrs:{"width":800,"height":800},on:{"content":_vm.getContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }